module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list', {
    staticClass: "md-double-line",
    attrs: {
      "id": "ql-sidenav-layer-list"
    }
  }, [_c('md-dialog-confirm', {
    ref: "deleteLayerDialog",
    attrs: {
      "md-title": 'Confirm Layer Delete',
      "md-content-html": 'This layer contains cues. Are you sure you want to delete it?',
      "md-ok-text": 'Yes',
      "md-cancel-text": 'Cancel'
    },
    on: {
      "close": _vm.dialogClose
    }
  }), _vm._v(" "), _vm._l((_vm.layers), function(layer) {
    return _c('layer', {
      key: layer.id,
      attrs: {
        "layer": layer,
        "viewable": _vm.canView(layer),
        "editable": _vm.canEdit(layer),
        "showNotes": _vm.canShowNotes(layer),
        "project": _vm.project
      },
      on: {
        "updateLayer": _vm.updateLayer,
        "deleteLayer": _vm.tryDeleteLayer,
        "showLayer": _vm.showLayer,
        "hideLayer": _vm.hideLayer
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b6420f2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/layers/layer-list.vue
// module id = 673
// module chunks = 2